export default {
    ListLoading: 'index:index:ListLoading1', // 流加载
    ListAdLoading: 'index:index:ListAdLoading1', // 流加载
    INDEXLIST: 'index:index:indexList1', // 获取列表
    INDEXADLIST: 'index:index:indexAdList1',
    STANDARLINELIST: 'index:index:standarlineList', //获取标准时间线
    STANDARLINELISTAdLoading: 'index:index:standarlineList:Loading',
};



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/newExportData/constant.js